import { apiSlice } from "./apiSlice";

export const missionApiSlice = apiSlice.injectEndpoints({
  tagTypes: [
    "DailyMissionCalendar",
    "Mission",
    "ClaimMission",
    "ClaimDailyLoginMission",
  ],
  endpoints: (builder) => ({
    getDailyMissionCalendar: builder.query({
      query: ({ userId, year, month }) => ({
        url: `missionBonus/api/getDailyMissionCalendar`,
        params: { userId, year, month },
      }),
      providesTags: ["DailyMissionCalendar"],
    }),
    getMission: builder.query({
      query: ({ userId }) => ({
        url: `missionBonus/api/getMission`,
        params: { userId },
      }),
      providesTags: ["Mission"],
    }),
    claimMission: builder.mutation({
      query: ({ playerMissionStatusId }) => ({
        url: `missionBonus/api/claimMission`,
        method: "POST", 
        params: { playerMissionStatusId },
      }),
      invalidatesTags: ["ClaimMission", "Mission", "DailyMissionCalendar", "Profile"],
    }),
    claimDailyLoginMission: builder.mutation({
      query: ({ userId, missionBonusId }) => ({
        url: `missionBonus/api/claimDailyLoginMission`,
        method: "POST", 
        params: { userId, missionBonusId },
      }),
      invalidatesTags: ["ClaimMission", "Mission", "DailyMissionCalendar", "Profile"],
    }),
  }),
});

export const {
    useGetDailyMissionCalendarQuery,
    useGetMissionQuery,
    useClaimMissionMutation,
    useClaimDailyLoginMissionMutation
} = missionApiSlice;

